import { create } from 'zustand'
import { persist, createJSONStorage } from 'zustand/middleware'
import { GlobalState } from '../../types/GlobalState'
import {
    Organization,
    Location,
    Practitioner,
    OrganizationAffiliation,
    InsurancePlan,
    PractitionerRole,
    HealthcareService,
    List,
    MedicationKnowledge,
    Endpoint
} from '@teschglobal/tg-fhir-react-components/dist/types'

export const useGlobalState = create<GlobalState>()(
    persist(
        (set) => ({
            fhirId: '',
            setFhirId: (fhirId: string) => set(() => ({ fhirId })),
            providerResource: 'Organization',
            setProviderResource: (providerResource: string) => set(() => ({ providerResource })),
            providerSearchTerms: '',
            setProviderSearchTerms: (providerSearchTerms: string) => set(() => ({ providerSearchTerms })),
            provider: null,
            setProvider: (provider: Practitioner | null) => set(() => ({ provider })),
            organization: null,
            setOrganization: (organization: Organization | null) => set(() => ({ organization })),
            organizationAffiliation: null,
            setOrganizationAffiliation: (organizationAffiliation: OrganizationAffiliation | null) => set(() => ({ organizationAffiliation })),
            insurancePlan: null,
            setInsurancePlan: (insurancePlan: InsurancePlan | null) => set(() => ({ insurancePlan })),
            location: null,
            setLocation: (location: Location | null) => set(() => ({ location })),
            healthcareService: null,
            setHealthcareService: (healthcareService: HealthcareService | null) => set(() => ({ healthcareService })),
            practitionerRole: null,
            setPractitionerRole: (practitionerRole: PractitionerRole | null) => set(() => ({ practitionerRole })),
            medicationKnowledge: null,
            setMedicationKnowledge: (medicationKnowledge: MedicationKnowledge | null) => set(() => ({ medicationKnowledge })),
            list: null,
            setList: (list: List | null) => set(() => ({ list })),
            practitioner: null,
            setPractitioner: (practitioner) => set({ practitioner }),
            endpoint: null,
            setEndpoint: (endpoint: Endpoint | null) => set({ endpoint }),
        }),
        {
            name: 'global-state-storage',
            storage: createJSONStorage(() => localStorage),
            partialize: (state) => ({
                fhirId: state.fhirId,
                providerResource: state.providerResource,
                provider: state.provider,
                organization: state.organization,
                organizationAffiliation: state.organizationAffiliation,
                insurancePlan: state.insurancePlan,
                location: state.location,
                healthcareService: state.healthcareService,
                practitionerRole: state.practitionerRole,
                medicationKnowledge: state.medicationKnowledge,
                list: state.list,
                practitioner: state.practitioner,
                endpoint: state.endpoint
            })
        }
    )
)